import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';
import { SCHOOL_PAUSED_PATH } from './SchoolLockHandler';

const BillingPage = lazy(() =>
  import('./pages/BillingPage').then(m => ({ default: m.BillingPage }))
);
const SchoolPausedPage = lazy(() =>
  import('./pages/SchoolPausedPage').then(m => ({ default: m.SchoolPausedPage }))
);

/**
 * Billing routes.
 *
 * `/billing` is ADMIN-ONLY (owner's call, 2026-09-07): money is the admin's
 * concern, and a pupil staring at a subscription page is just confusing — the
 * API stays `IsSchoolMember` (the dashboard card and the 402 body still read
 * it), only the page is gated.
 *
 * `/school-paused` stays open to EVERY role: a pupil of a locked school is
 * routed there by the `school_locked` handler and must be able to land. Both
 * routes sit inside the AppShell deliberately: the header carries the school
 * switcher, which is the way out for someone locked in one school and paid up
 * in another.
 */
export const billingRoutes = (
  <>
    <Route element={<RequireRole roles={['admin']} />}>
      <Route path="/billing" element={<BillingPage />} />
    </Route>
    <Route element={<RequireRole roles={['admin', 'teacher', 'pupil', 'parent']} />}>
      <Route path={SCHOOL_PAUSED_PATH} element={<SchoolPausedPage />} />
    </Route>
  </>
);
